import PageHelmet from "../../../components/common/Helmet";
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../components/header/HeaderThree";
import Footer from "../../../components/footer/Footer";
import InnoFestHackathonNewsGallery from "./InnoFestHackathonNews_Gallery";
import PageScrollTop from "../../../components/pageScrollTop/PageScrollTop";

export default function InnoFestHackathonNews() {
	const { showBackToTop, scrollToTop } = PageScrollTop();

	return (
		<>
			{/* Start Pagehelmet  */}
			<PageHelmet pageTitle="InnoFest Hackathon" />
			{/* End Pagehelmet  */}

			<Header />

			{/* Start Breadcrump Area */}
			<div className="rn-page-title-area pt--20 pb--60" data-black-overlay="7">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="rn-page-title text-center pt--100">
								<h2 className="title theme-gradient">InnoFest Hackathon</h2>
								<p>28/06/2024</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* End Breadcrump Area */}

			{/* Start Page Wrapper */}
			<div className="rn-service-details ptb--30 bg_color--1">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="service-details-inner">
								<div className="inner">
									{/* Start Single Area */}
									<div className="row sercice-details-content pb--20 align-items-center">
										<div className="col-lg-12 col-12">
											<div className="details mt_md--30 mt_sm--30">
												<h4 className="title">Overview</h4>
												<p>
													We are pleased to announce that at the invitation of
													Arshak Balyan ArmSTQB co-founder ԻննոԻջեւան /
													InnoIjevan and TestingArt co-founder have participated
													in the "Innofest" hackathon organized by Union of
													Advanced Technology Enterprises-UATE as jury members.
												</p>
												<p>
													During this hackathon, the teams presented their ideas
													to the jury after a 24-hour sleepless night.
												</p>
												<p>
													The winners of the event presented innovative and
													useful solutions that inspired everyone.
													<br />
													We sincerely congratulate the winners and wish them new
													successes.
													<br />
													We also thank the organizers of the event for this
													interesting and conceptual hackathon.
													<br />
													We are proud to have participated and invested in this
													important event, promoting innovation development and
													supporting young talent.
												</p>
												<h4 className="title">Gallery</h4>
												<InnoFestHackathonNewsGallery column="col-lg-3 col-md-6 col-sm-6 col-12" />
											</div>
										</div>
									</div>
									{/* End Single Area */}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* End Page Wrapper */}

			{/* Start Back To Top */}
			{showBackToTop && (
				<div className="backto-top" style={{ display: showBackToTop ? "block" : "none" }}>
					<div>
						<div onClick={scrollToTop} className="backto-top">
							<FiChevronUp />
						</div>
					</div>
				</div>
			)}
			{/* End Back To Top */}

			<Footer />
		</>
	);
}
